var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$errorFlg)?_c('p',{staticClass:"commonError"},[_vm._v(_vm._s(_vm.$msg.ERROR.MSG_9998)),_c('br'),_vm._v(_vm._s(_vm.$msg.ERROR.MSG_9999))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }